import { getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getAllInUnitAmenitiesAsync = createAsync(function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      applyToHomeDashboardStore: false
    },
    applyToHomeDashboardStore = _ref.applyToHomeDashboardStore;
  return async function getAllInUnitAmenities(options) {
    const resp = await api.InUnitAmenities.getAllInUnitAmenities(options);
    getParent(this).addNewProperty.unitSetup.setAmenities(resp.response);
    if (applyToHomeDashboardStore) {
      var _getParent$homeDashbo;
      (_getParent$homeDashbo = getParent(this).homeDashboardStore.getCurrentCompany) === null || _getParent$homeDashbo === void 0 || _getParent$homeDashbo.selectedPropertyDetails().details.unitSetup.setAmenities(resp.response);
    }
    return resp;
  };
});
const InUnitAmenitiesStore = types.model('InUnitAmenitiesStore', {
  getAllInUnitAmenitiesAsync
});
export const inUnitAmenities = types.optional(InUnitAmenitiesStore, {});